import React, { useState } from "react";
import "./MenuButton.css";

import { categoryLinkService } from "../../services/categoryLinks.service";

export default function MenuButton(props) {
  const { categories, lang } = props;
  const [isShowCategories, setIsShowCategories] = useState(false);
  let btnText = "Menu";

  const swhitchShowCategories = () => {
    setIsShowCategories(!isShowCategories);
  };

  if (isShowCategories) {
    return (
      <CategoriesListCard
        categories={categories}
        swhitchShowCategories={swhitchShowCategories}
      />
    );
  }

  // get correct language for button text
  switch (lang) {
    case "es":
      btnText = "Ver Menú";
      break;
    case "en":
      btnText = "Show Menu";
      break;
  }

  return (
    <button className="category-button" onClick={swhitchShowCategories}>
      {btnText} <i className="fas fa-caret-down"></i>
    </button>
  );
}

const CategoriesListCard = (props) => {
  const { categories, swhitchShowCategories } = props;
  return (
    <div className="categories-list-card">
      <ul>
        {categories.map((cat, index) => {
          return (
            <CategoryItem
              key={index}
              cat={cat}
              onChangeCategory={swhitchShowCategories}
            />
          );
        })}
      </ul>
      <button onClick={swhitchShowCategories}>
        <i className="close-categories fas fa-times-circle"></i>
      </button>
    </div>
  );
};

const CategoryItem = (props) => {
  const { cat, onChangeCategory } = props;

  return (
    <li>
      <a href={`#${cat}`} alt={cat} onClick={onChangeCategory}>
        {cat} <i className="fas fa-angle-right"></i>
      </a>
    </li>
  );
};
